import styled from "styled-components";

export const Container = styled.main`
  max-width: 1180px;
  margin: 0 auto;
  padding: 24px 16px 72px;
  min-height: calc(100vh - var(--header-height));

  @media (min-width: 768px) {
    padding: 48px 28px 96px;
  }
`;

export const AuthContainer = styled.main`
  width: min(100%, 520px);
  margin: 0 auto;
  padding: 32px 16px 64px;
  min-height: calc(100vh - var(--header-height));
  display: flex;
  align-items: center;
  justify-content: center;

  @media (min-width: 768px) {
    padding: 64px 24px 96px;
  }
`;

